import { FunctionComponent, useEffect, useMemo, useState } from "react";

import { HStack, VStack } from "@chakra-ui/react";

import { Button, Typography, Loader } from "@tether-web-portal/components/common";
import dayjs from "@tether-web-portal/dayjs-setup";
import { useOccupancyContext } from "@tether-web-portal/contexts/OccupancyContext";
import { useOccupancyExportData } from "@tether-web-portal/hooks/useOccupancyExportData";
import { makeFloorLevelSpaceName, OccupancyFilterType } from "@tether-web-portal/web-workers/occupancy";
import { MetricsIntervalSelector } from "@tether-web-portal/components/metrics/MetricsIntervalSelector";
import { MetricDataInterval } from "@tether-web-portal/types/metricsTypes";

const MetricDateRangeOptions = [
  MetricDataInterval.MINUTES_15,
  MetricDataInterval.HOURS_24,
  MetricDataInterval.DAYS_7,
  MetricDataInterval.DAYS_30,
  MetricDataInterval.MONTHS_3,
  MetricDataInterval.CUSTOM,
];

export const OccupancyPageHeader: FunctionComponent = () => {
  const { dataLastUpdatedAt, dataLoading, isLiveView, pageFilters, utilisationTableData } =
    useOccupancyContext();
  const { onExportData, isExportAble, loading: exportLoading } = useOccupancyExportData();

  const [dataLastUpdatedLabel, setDataLastUpdatedLabel] = useState<string>();

  const headerTitle = useMemo(() => {
    let updatedHeaderTitle: string | null = null;
    if (pageFilters?.spaceType === OccupancyFilterType.FLOOR) {
      updatedHeaderTitle = makeFloorLevelSpaceName(pageFilters.floorIndex ?? 0);
    } else if (pageFilters?.spaceType === OccupancyFilterType.ROOM) {
      updatedHeaderTitle =
        (utilisationTableData ?? []).find((x) => x.spaceId === pageFilters.spaceId)?.spaceName ?? null;
    }

    return updatedHeaderTitle || "Occupancy";
  }, [pageFilters, utilisationTableData]);

  useEffect(() => {
    if (!dataLastUpdatedAt) {
      return;
    }

    setDataLastUpdatedLabel(`Data updated ${dayjs(dataLastUpdatedAt).fromNow()}`);
  }, [dataLastUpdatedAt]);

  return (
    <HStack justifyContent="space-between" alignItems="center">
      <VStack alignItems="flex-start">
        <Typography size="2xl" fontWeight="bold">
          {headerTitle}
        </Typography>
        {dataLastUpdatedLabel && (
          <Typography size="sm" color="gray">
            {dataLastUpdatedLabel}
          </Typography>
        )}
      </VStack>

      <HStack alignItems="center" columnGap={2}>
        <Loader size="sm" isLoading={dataLoading} />

        <MetricsIntervalSelector options={MetricDateRangeOptions} />

        {!isLiveView && (
          <Button onClick={onExportData} loading={exportLoading} disabled={dataLoading || !isExportAble}>
            Export
          </Button>
        )}
      </HStack>
    </HStack>
  );
};
